export const generateArray = (itemCount: number): number[] => Array(itemCount).fill(0).map((_: number, i: number): number => i);